import { AssetTypeModel } from "./asset-type.model";
import { AssetModel } from "./asset.model";
import { FileModel } from "./file.model";
import { FilterModel } from "./filter.model";
import { GeoObjectModel } from "./geoobject.model";
import { HeicCertModel } from "./heic_cert.model";
import { HistoryModel } from "./history.model";
import { ObservationModel } from "./observation.model";
import { RepairModel } from "./repair.model";
import { RiskFormModel } from "./risk-form.model";

export class JobModel {

  jobUid: number;
  clientUid: number;
  locationUid: number;
  clientOrderNumber: string;
  jobDate: string;
  jobDateReadable: string;
  jobDateMysql: string;
  visitNumber: number;
  jobInformation: string;
  locationName: string;
  addressOne: string;
  addressTwo: string;
  addressCity: string;
  postCode: string;
  locationEstate: string;

  observations: Array<ObservationModel> = [];
  assignableAssetTypes: Array<AssetTypeModel> = [];

  priority: number;
  jobTypeSelect: FilterModel;
  jobTypeUid: number;
  jobTypeName: string;
  assets: Array<AssetModel> = [];
  jobStatusSelect: FilterModel;
  jobStatusUid: number;
  jobStatusName: string;
  organisationSelect: FilterModel;
  organisationUid: number;
  organisationName: string;
  
  userDesignerSelect: FilterModel;
  userDesignerUid: number;
  userDesignerName: string
  userDesignerDate: string;
  userDesignerDateReadable: string;
  userDesignerDateMysql: string;

  userInstallerSelect: FilterModel;
  userInstallerUid: number;
  userInstallerName: string
  userInstallerDate: string;
  userInstallerDateReadable: string;
  userInstallerDateMysql: string;
  userInstallerNotes: string;

  userManagerSelect: FilterModel;
  userManagerUid: number;
  userManagerName: string
  userManagerDate: string;
  userManagerDateReadable: string;
  userManagerDateMysql: string;
  userManagerNotes: string;
  returnNeededNotes: string;

  files: Array<FileModel> = [];
  history: Array<HistoryModel> = [];

  locationGeoJson: Array<GeoObjectModel> = [];
  locationLat: number;
  locationLon: number;

  designerSignatureFound: boolean;
  designerSignature: string;
  installerSignatureFound: boolean;
  installerSignature: string;
  managerSignatureFound: boolean;
  managerSignature: string;

  heicCertificate: HeicCertModel;
  riskForm: RiskFormModel;
  riskFormMessage: string;
  jobId: string;
  repairs: Array<RepairModel> = [];
  recommendations: Array<RepairModel> = [];

  constructor() {

    this.locationLat = 53.36657;
    this.locationLon = -2.82198;
  }
}